module.exports = __webpack_public_path__ + "img/008.bd2e1675.png";